var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{class:['cancel_heading', {'is-centered': _vm.isCentered}]},[_vm._t("default")],2),_vm._v(" "),(_vm.subheading)?_c('p',{staticClass:"cancel_subheading"},[_vm._v(_vm._s(_vm.subheading))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }